import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { usePostHog } from 'posthog-js/react'

/**
 * Logs page views, within the SPA, to PostHog. Needs
 * to be placed next to the main App component within the
 * appropriate router.
 *
 * Shamelessly stolen from PostHog's example:
 * https://posthog.com/tutorials/single-page-app-pageviews
 * @returns
 */
export const PostHogPageView = () => {
  const location = useLocation()
  const posthog = usePostHog()

  // Track pageviews
  useEffect(() => {
    if (posthog) {
      posthog.capture('$pageview', {
        $current_url: window.location.href
      })
    }
  }, [location, posthog])

  return null
}
